import LocalizedStrings from 'react-localization'
import en from './translation.en'
import nl from './translation.nl'

export const strings = new LocalizedStrings({
  en: en,
  nl: nl,
})
